export enum SharingTypes {
    Screen = 'screenSharing',
    Slides = 'slides'
}
